import React from 'react';

export const Card = ({ children, className = '', noPadding = false }) => {
  return (
    <div className={`bg-brand-card rounded-2xl border border-brand-border shadow-sm overflow-hidden ${noPadding ? '' : 'p-6 sm:p-8'} ${className}`}>
      {children}
    </div>
  );
};